import { Navbar } from '@/components/Navbar/Navbar.js';
import { InquiryButton, TextLinks } from '@/components/Navbar/Navbar.styles.js';
import { Text } from '@/components/ThemeButton/ThemeButton.styles.js';
import { styled } from '@/stitches/index.js';
import { isTheme } from '@/stitches/isTheme.js';
import { morning } from '@/templates/sydney/themes/morning.js';
import { pxToRem } from '@/utilities/pxToRem.js';

export const StyledNavbar = styled(Navbar, {
  [`${TextLinks}`]: {
    gap: '$32',
  },
  [`& * ${InquiryButton}`]: {
    [`${Text}`]: {
      fontWeight: 500,
    },
    borderWidth: pxToRem(1),
  },
  $$mobileThemeButtonFontColor: '$colors$pageBackground',
  $$themeButtonBackground: '$colors$defaultFont',
  $$themeButtonFontColor: '$colors$pageBackground',
  minHeight: 'auto',
  padding: '$20 0 0',
  span: {
    fontSize: '$16',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  // eslint-disable-next-line canonical/sort-keys
  '@bp2': {
    minHeight: '$108',
    padding: '$32 0 0',
  },
  h5: {
    '@bp0': {
      lineHeight: 1.5,
    },
    '@bp2': {
      lineHeight: 1,
    },
    [isTheme([morning])]: {
      fontWeight: 400,
    },
    color: '$defaultFont',
    cursor: 'pointer',
    fontFamily: '$heading',
    fontSize: '$32',
    fontWeight: 500,
    letterSpacing: '-$0_01',
    paddingRight: '$48',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
});
